import { render, staticRenderFns } from "./ULoadingCircularCenter.vue?vue&type=template&id=48f59398&scoped=true&"
import script from "./ULoadingCircularCenter.vue?vue&type=script&lang=js&"
export * from "./ULoadingCircularCenter.vue?vue&type=script&lang=js&"
import style0 from "./ULoadingCircularCenter.vue?vue&type=style&index=0&id=48f59398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f59398",
  null
  
)

export default component.exports